export default __webpack_public_path__ + "static/media/Group_8412.48a460b7.svg";